import { createContext } from "react";

export const CommLogStateContext = createContext();
